var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderDashed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 735,
    height: 112,
    viewBox: "0 0 735 112",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 735,
    height: 112,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.003A4.004 4.004 0 0 1 3.999 0H731a3.994 3.994 0 0 1 4 4.003v103.994a4.004 4.004 0 0 1-3.999 4.003H4a3.994 3.994 0 0 1-4-4.003V4.003z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.003A4.004 4.004 0 0 1 3.999 0H731a3.994 3.994 0 0 1 4 4.003v103.994a4.004 4.004 0 0 1-3.999 4.003H4a3.994 3.994 0 0 1-4-4.003V4.003z",
    stroke: "#C3C3CB",
    mask: "url(#a)",
    strokeWidth: 2,
    strokeDasharray: 4,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderDashed);
export default __webpack_public_path__ + "static/media/border-dashed.59aa404aef8548938ae76c47c8be2a31.svg";
export { ForwardRef as ReactComponent };